<template>
  <div style="padding:10px">
  
      <van-cell style="background-color: white;border:1px solid #ccc" icon="filter-o" right-icon=""	@click-right-icon="filtrele" @click="t1=true" center clearable  :title="obje.t1+' # '+obje.t2"/>
  
      <van-pull-refresh v-model="isLoading" @refresh="filtrele">
        <router-link v-for="(item, index) in $store.getters.getSatis" :key="index" :to="'/satis/'+item.sira">
          <van-cell :title="$helper.ilkharfBuyuk(item.unvan).substring(0, 70)" :label="item.seri+' '+item.sira+' # '+$helper.parabirimi(item.toplam,hesap.pb)" icon="todo-list-o" style="padding-left:2px" :value="item.tarih" />
        </router-link>  
      </van-pull-refresh>
      <van-calendar type="range" v-model="t1" @confirm="onConfirm" :min-date="minDate" />
  
      
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        hesap : this.$store.getters.getHesap,
        isLoading: false,
        obje : {
        pkod:this.$store.getters.getHesap.entegrekodu,
        ckod:0,
        t1: this.$helper.setFiltre().yillik.t1,
        t2: this.$helper.setFiltre().yillik.t2,
        durum : 2   
      },
        t1:false,
        minDate: new Date(2023, 10, 1),  //10 ekim ayı değil +1 mantığı ile aralık
        maxDate: new Date(2023, 10, 2),
      };
    },
    created(){
      this.$store.commit("setLoading",[false,'...'])
      this.filtrele()
    },
  methods: {
      baslat(){
        this.t1=false;
        this.filtrele();
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
      },
      onConfirm(date) {
        this.t1 = false;
        const [start, end] = date;
        this.obje.t2 = `${this.formatDate(end)}`
        this.obje.t1 = `${this.formatDate(start)}`
        this.filtrele()
      },
      filtrele() {
      this.$store.commit('setSatis',[])
      this.$store.commit("setLoading",[true,'Bekleyiniz'])
  
        this.$request
          .post(this.hesap.program+"/plasiyer/siparis", this.obje,this.hesap)
          .then((response) => {
            console.log(response)
            if (response.status != 300) {
              this.$store.commit('setSatis',response.response);
              this.$store.commit("setLoading",[false,'...']);
              this.isLoading = false;
            }
            else{
              this.$router.push("/oturum")
            }
  
          }).catch(err=>{
            this.$store.commit("setLoading",[false,'...']);
            this.$notify({ type: 'danger', message: err.message });
          })
      },
  },
  };
  </script>
  <style scoped>
  .van-icon-filter-o,.van-icon-calendar-o,.van-icon-search{
    color:#484848 !important;
    font-size:16px !important;
  }

  .van-cell__left-icon{
    font-size:18px !important
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/satis.vue